<template>
  <div>
    <el-dialog :title="$t('Dəymiş_zərər_haqqında_məlumat')" :close-on-press-escape="false" :close-on-click-modal="false"
      :visible.sync="showModal" :width="dialogWidth" top="1vh" append-to-body>
      <br>
      <el-form :disabled="disabled" style="margin-top: -25px;" ref="report" :label-width="labelWidth">
        <span class="custom-span">{{$t('Avtomobilin_ümumi_hissələri')}}</span>
        <hr>


        <div class="main-image-container">
          <img src="@/assets/Full Car.png" class="FullCarImg">
          <img v-for="(image, index) in images" :ref="'images'" :key="index" :src="image.srcT"
            @click="($event) => handleClick($event, image.id)" :style="image.styl">
        </div>
        <br>
        <span class="custom-span">{{$t('Avtomobilin_salon_hissələri')}}</span>
        <hr>
        <div class="main-image-container-2">
          <img src="@/assets/Full Salone.png" class="FullCarImg">
          <img v-for="(image, index) in imagesIn" :ref="'images'" :key="index" :src="image.srcT"
            @click="($event) => handleClick($event, image.id)" :style="image.styl">

        </div>

        <hr>
        <div class="row">
          <!-- Tablo için Sol Sütun -->
          <div class="col-md-6">
            <div class="selected-parts-list">
              <table>
                <thead>
                  <tr>
                    <th>{{$t('Seçilən_hissələr')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(partDescription) in selectedParts" :key="partDescription">
                    <td>{{ partDescription }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br>
          <div class="col-md-6">
            <span class="custom-span-left">{{$t('Avtomobilin_ön_hissəsi')}}</span>
            <hr>
            <div class="row">
              <div class="col-md-12">
                <el-form-item label="Alt işlək hissə " style="font-weight: bold;">
                  <el-checkbox :true-label="1" :false-label="0" v-model="item.frontUnderCarriageLeft" :label="$t('Sol')" />
                  <el-checkbox :true-label="1" :false-label="0" v-model="item.frontUnderCarriageRight" :label="$t('Sağ')" />
                </el-form-item>

                <div class="row">
                  <div class="col-md-6">
                    <el-form-item :label="$t('Park_radar')" style="font-weight: bold;">
                      <el-checkbox :true-label="1" :false-label="0" v-model="item.frontParkingSensor"></el-checkbox>
                    </el-form-item>
                  </div>
                  <div class="col-md-6">
                    <el-form-item :label="$t('Mühərrik_hissəsi')" style="font-weight: bold;">
                      <el-checkbox :true-label="1" :false-label="0" v-model="item.enginePart"></el-checkbox>
                    </el-form-item>
                  </div>
                </div>

                <el-form-item :label="$t('Qeyd')">
                  <el-input rows="3" type="textarea" v-model="item.frontDescr"></el-input>
                </el-form-item>
              </div>
            </div>
            <span class="custom-span-left">{{$t('Avtomobilin_arxa_hissəsi')}}</span>
            <hr>

            <div class="row">
              <div class="col-md-12">

                <div class="row">
                  <div class="col-md-8">
                    <el-form-item label="Alt işlək hissə " style="font-weight: bold;">

                      <el-checkbox :true-label="1" :false-label="0" v-model="item.backUnderCarriageLeft" :label="$t('Sol')" />
                      <el-checkbox :true-label="1" :false-label="0" v-model="item.backUnderCarriageRight" :label="$t('Sağ')" />
                    </el-form-item>
                  </div>
                  <div class="col-md-4">
                    <div style="margin-left: -85px;">

                      <el-form-item :label="$t('Park_radar')" style="font-weight: bold;">
                        <el-checkbox :true-label="1" :false-label="0" v-model="item.rearParkingSensor"></el-checkbox>
                      </el-form-item>
                    </div>
                  </div>
                </div>

                <el-form-item :label="$t('Qeyd')">
                  <el-input rows="3" type="textarea" v-model="item.backDescr"></el-input>
                </el-form-item>
              </div>
            </div>
            <span class="custom-span-left">{{$t('Avtomobilin_salonu')}}</span>
            <hr>
            <div class="row">
              <div class="col-md-12">


                <div class="row">
                  <div class="col-md-12">
                    <el-form-item :label="$t('Hava_yastıqları')" style="font-weight: bold;">
                      <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorSteeringWheelAirbag"
                        :label="$t('Sükan')" />
                      <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorDashboardAirbag"
                        :label="$t('Torped')" />
                      <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorPillarAirbag" :label="$t('Dirək')" />
                      <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorKneeAirbag" :label="$t('Dizlik')" />
                    </el-form-item>


                    <el-form-item :label="$t('Dam')" style="font-weight: bold;">

                      <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorLeftSide" :label="$t('Sol')" />
                      <el-checkbox style="margin-left: 20px;" :true-label="1" :false-label="0"
                        v-model="item.interiorRightSide" :label="$t('Sağ')" />
                    </el-form-item>

                    <div class="row">
                      <div class="col-md-6">
                        <el-form-item :label="$t('Güzgü')" style="font-weight: bold;">
                          <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorWindow"></el-checkbox>
                        </el-form-item>

                      </div>
                      <div class="col-md-6">
                        <el-form-item :label="$t('Dam_üzlüyü')" style="font-weight: bold;">
                          <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorRoofPanel"></el-checkbox>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-4">
                    <div style="margin-left: -85px;">

                      <el-form-item :label="$t('Güzgü')" style="font-weight: bold;">
                        <el-checkbox :true-label="1" :false-label="0" v-model="item.interiorWindow"></el-checkbox>
                      </el-form-item>


                    </div>
                  </div> -->
                </div>



                <el-form-item :label="$t('Qeyd')">
                  <el-input rows="3" type="textarea" v-model="item.interiorDescr"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>

      <br><br><br>
      <span slot="footer" class="dialog-footer">
      
        <el-button size="small" v-if="shouldShowButton" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="handleClose">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  CreateParticipantReport,
  UpdateParticipantReport,
  GetParticipantReport,
} from "../../services/common";
import { ParticipantReport } from "src/services/types";
import { LastAccidentStatus } from "../../services/common";

export default {


  data() {
    return {
      activeName: "auto1",
      showModal: false,
      mode: "",
      loading: false,
      item: {},
      participantId: null,
      uid: this.$store.state.user.id,
      createUserId: null,
      labelWidth: '',
      dialogWidth: '',
      disabled: false,
      images: this.getDefaultImages(),
      imagesIn: this.getDefaultImagesIn(),
      hueValue: 100,
      hueVisible: false,
      lastClickedPart: null,
      accidentStatus: null,
      accidentId: null,
      partDescriptions: {
        frontDoorLeft: this.$t('Avtomobilin_ön_hissəsi_sol_qapı'),
        frontDoorRight: this.$t('Avtomobilin_ön_hissəsi_sağ_qapı'),
        frontDoorWindowLeft: this.$t('Avtomobilin_ön_hissəsi_sol_qapının_şüşəsi'),
        frontDoorWindowRight: this.$t('Avtomobilin_ön_hissəsi_sağ_qapının_şüşəsi'),
        frontMirrorLeft: this.$t('Avtomobilin_ön_hissəsi_sol_güzgü'),
        frontMirrorRight: this.$t('Avtomobilin_ön_hissəsi_sağ_güzgü'),
        frontWheelLeft: this.$t('Avtomobilin_ön_hissəsi_sol_təkər'),
        frontWheelRight: this.$t('Avtomobilin_ön_hissəsi_sağ_təkər'),
        frontHeadlightLeft: this.$t('Avtomobilin_ön_hissəsi_sol_blokfarası'),
        frontHeadlightRight: this.$t('Avtomobilin_ön_hissəsi_sağ_blokfarası'),
        frontTurnSignalLeft: this.$t('Avtomobilin_ön_hissəsi_sol_dönmə_göstəricisi'),
        frontTurnSignalRight: this.$t('Avtomobilin_ön_hissəsi_sağ_dönmə_göstəricisi'),
        frontFenderLeft: this.$t('Avtomobilin_ön_hissəsi_sol_qanad'),
        frontFenderRight: this.$t('Avtomobilin_ön_hissəsi_sağ_qanad'),
        frontDiskLeft: this.$t('Avtomobilin_ön_hissəsi_sol_disk'),
        frontDiskRight: this.$t('Avtomobilin_ön_hissəsi_sağ_disk'),
        frontUnderCarriageLeft: this.$t('Avtomobilin_ön_hissəsi_sol_alt_işlək_hissə'),
        frontUnderCarriageRight: this.$t('Avtomobilin_ön_hissəsi_sağ_alt_işlək_hissə'),
        frontFootboardLeft: this.$t('Avtomobilin_ön_hissəsi_sol_ayaqaltı'),
        frontFootboardRight: this.$t('Avtomobilin_ön_hissəsi_sağ_ayaqaltı'),
        frontPillarLeft: this.$t('Avtomobilin_ön_hissəsi_sol_dirək'),
        frontPillarRight: this.$t('Avtomobilin_ön_hissəsi_sağ_dirək'),
        frontFogLightLeft: this.$t('Avtomobilin_ön_hissəsi_sol_duman_farası'),
        frontFogLightRight: this.$t('Avtomobilin_ön_hissəsi_sağ_duman_farası'),
        frontWheelWellLeft: this.$t('Avtomobilin_ön_hissəsi_sol_qanad_altı'),
        frontWheelWellRight: this.$t('Avtomobilin_ön_hissəsi_sağ_qanad_altı'),
        visor: this.$t('Avtomobilin_ön_hissəsi_üzlük'),
        windshield: this.$t('Avtomobilin_ön_hissəsi_ön_şüşə'),
        frontBumper: this.$t('Avtomobilin_ön_hissəsi_bamper'),
        hood: this.$t('Avtomobilin_ön_hissəsi_kapot'),
        enginePart: this.$t('Avtomobilin_ön_hissəsi_mühərrik_hissəsi'),
        backDoorLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_qapı'),
        backDoorRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_qapı'),
        backDoorWindowLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_qapının_şüşəsi'),
        backDoorWindowRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_qapının_şüşəsi'),
        backTailLightLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_stop'),
        backTailLightRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_stop'),
        backWheelLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_təkər'),
        backWheelRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_təkər'),
        backFenderLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_qanad'),
        backFenderRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_qanad'),
        backDiskLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_disk'),
        backDiskRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_disk'),
        backUnderCarriageLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_alt_işlək_hissə'),
        backUnderCarriageRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_alt_işlək_hissə'),
        backFootboardLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_ayaqaltı'),
        backFootboardRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_ayaqaltı'),
        backPillarLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_dirək'),
        backPillarRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_dirək'),
        backLightReflectorLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_işıq_qaytarıcı'),
        backLightReflectorRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_işıq_qaytarıcı'),
        backWheelWellLeft: this.$t('Avtomobilin_arxa_hissəsi_sol_qanad_altı'),
        backWheelWellRight: this.$t('Avtomobilin_arxa_hissəsi_sağ_qanad_altı'),
        muffler: this.$t('Avtomobilin_arxa_hissəsi_səsboğucu'),
        rearWinscreen: this.$t('Avtomobilin_arxa_hissəsi_arxa_şüşə'),
        backBumper: this.$t('Avtomobilin_arxa_hissəsi_bamper'),
        spoiler: this.$t('Avtomobilin_arxa_hissəsi_spoyler'),
        dashboard: this.$t('Avtomobilin_arxa_hissəsi_panel'),
        tailgate: this.$t('Avtomobilin_arxa_hissəsi_yük_qapısı'),
        interiorSteeringWheelAirbag: this.$t('Avtomobil_salonu_sükan_hava_yastığı'),
        interiorDashboardAirbag: this.$t('Avtomobil_salonu_torped_hava_yastığı'),
        interiorPillarAirbag: this.$t('Avtomobil_salonu_dirək_hava_yastığı'),
        interiorKneeAirbag: this.$t('Avtomobil_salonu_dizlik_hava_yastığı'),
        interiorLeftDoor: this.$t('Avtomobil_salonu_sol_qapı'),
        interiorRightDoor: this.$t('Avtomobil_salonu_sağ_qapı'),
        interiorFrontDoor: this.$t('Avtomobil_salonu_ön_qapı'),
        interiorRearDoor: this.$t('Avtomobil_salonu_arxa_qapı'),
        interiorLeftSeat: "Avtomobil salonu sol oturacaq",
        interiorRightSeat: this.$t('Avtomobil_salonu_sağ_oturacaq'),
        interiorFrontSeat: this.$t('Avtomobil_salonu_ön_oturacaq'),
        interiorRearSeat: "Avtomobil salonu arxa oturacaq",
        interiorLeftSide: "Avtomobil salonu sol dam",
        interiorRightSide: this.$t('Avtomobil_salonu_sağ_dam'),
        interiorLeftDoorPanel: this.$t('Avtomobil_salonu_sol_qapı_üzlüyü'),
        interiorRightDoorPanel: this.$t('Avtomobil_salonu_sağ_qapı_üzlüyü'),
        interiorFrontDoorPanel: this.$t('Avtomobil_salonu_ön_qapı_üzlüyü'),
        interiorRearDoorPanel: this.$t('Avtomobil_salonu_arxa_qapı_üzlüyü'),
        interiorWindow: this.$t('Avtomobil_salonu_güzgü'),
        interiorMultimedia: "Avtomobil salonu multimedya",
        interiorDashboard: "Avtomobil salonu torped",
        interiorDoorPanels: this.$t('Avtomobil_salonu_qapı_üzlükləri'),
        interiorRoofPanel: this.$t('Avtomobil_salonu_dam_üzlüyü'),
        interiorSteeringWheel: this.$t('Avtomobil_salonu_sükan'),
        frontParkingSensor: this.$t('Avtomobilin_park_radarı_ön'),
        rearParkingSensor: this.$t('Avtomobilin_park_radarı_arxa'),
        otherRoofPart: this.$t('Avtomobilin_digər_hissələri_dam_hissəsi'),
        otherPillar: this.$t('Avtomobilin_digər_hissələri_dirək'),
        otherSunRoof: this.$t('Avtomobilin_digər_hissələri_lyük'),
        centerRightPillar: this.$t('Avtomobilin_digər_hissələri_sağ_dirək'),
        centerLeftPillar: this.$t('Avtomobilin_digər_hissələri_sol_dirək'),
      },
    };
  },
  computed: {
    isFormDisabled() {
      return this.accidentStatus >= 151;
    },
    shouldShowButton() {
      return !this.disabled && (!this.item.createUser || this.uid === this.item.createUser) && !this.isFormDisabled;
    },
    selectedParts() {
      let selected = [];
      for (let partName in this.item) {
        if (this.item[partName] === 1) {
          selected.push(this.partDescriptions[partName]);
        }
      }

      if (this.lastClickedPart && this.item[this.lastClickedPart] === 1) {
        const lastPartDescription = this.partDescriptions[this.lastClickedPart];
        selected = selected.filter(desc => desc !== lastPartDescription);
        selected.unshift(lastPartDescription);
      }

      return selected;
    },
  },



  methods: {
    getDefaultImages() {
      return [
        { id: 48, srcT: require("@/assets/Front Barbell.png"), styl: { opacity: 0, partName: 'frontPillarLeft', position: 'absolute', top: '75.2%', left: '29.9%', width: '3.5%' } },
        { id: 49, srcT: require("@/assets/Left Barbell.png"), styl: { opacity: 0, partName: 'frontPillarRight', position: 'absolute', top: '5.5%', left: '29.9%', width: '3.5%' } },
        { id: 54, srcT: require("@/assets/Barbell.png"), styl: { opacity: 0, partName: 'centerLeftPillar', position: 'absolute', top: '66%', left: '48.5%', width: '3%' } },
        { id: 55, srcT: require("@/assets/Right Barbell.png"), styl: { opacity: 0, partName: 'centerRightPillar', position: 'absolute', top: '5.7%', left: '48.5%', width: '3%' } },

        { id: 1, srcT: require("@/assets/Baggage.png"), styl: { opacity: 0, position: 'absolute', partName: 'tailgate', top: '31.4%', left: '61.3%', width: '20.85%' } },
        { id: 2, srcT: require("@/assets/Back Window.png"), styl: { opacity: 0, partName: 'rearWinscreen', position: 'absolute', top: '34.3%', left: '62.2%', width: '10.65%' } },

        { id: 3, srcT: require("@/assets/Top.png"), styl: { opacity: 0, partName: 'otherRoofPart', position: 'absolute', top: '35.7%', left: '40.6%', width: '21.7%' } },
        { id: 4, srcT: require("@/assets/Up Window.png"), styl: { opacity: 0, partName: 'otherSunRoof', position: 'absolute', top: '41.4%', left: '43.9%', width: '6.7%' } },

        { id: 5, srcT: require("@/assets/Front Window.png"), styl: { opacity: 0, partName: 'windshield', position: 'absolute', top: '32.2%', left: '31.7%', width: '9.8%' } },
        { id: 6, srcT: require("@/assets/Hood.png"), styl: { opacity: 0, partName: 'hood', position: 'absolute', top: '32.2%', left: '14.3%', width: '18.9%' } },

        { id: 7, srcT: require("@/assets/Left Front Door.png"), styl: { opacity: 0, partName: 'frontDoorLeft', position: 'absolute', top: '65.7%', left: '32.1%', width: '17.6%' } },
        { id: 8, srcT: require("@/assets/Right Front Door.png"), styl: { opacity: 0, partName: 'frontDoorRight', position: 'absolute', top: '8.8%', left: '32.1%', width: '17.6%' } },
        { id: 9, srcT: require("@/assets/Front Door Window.png"), styl: { opacity: 0, partName: 'frontDoorWindowLeft', position: 'absolute', top: '66.9%', left: '34.4%', width: '15.2%', } },
        { id: 10, srcT: require("@/assets/Left Window.png"), styl: { opacity: 0, partName: 'frontDoorWindowRight', position: 'absolute', top: '23.5%', left: '34.4%', width: '15.2%' } },

        { id: 11, srcT: require("@/assets/Mirror.png"), styl: { opacity: 0, partName: 'frontMirrorLeft', position: 'absolute', top: '67.5%', left: '32%', width: '2.7%' } },
        { id: 12, srcT: require("@/assets/Left Mirror.png"), styl: { opacity: 0, partName: 'frontMirrorRight', position: 'absolute', top: '27.9%', left: '32.5%', width: '2.7%' } },

        { id: 27, srcT: require("@/assets/Bumper.png"), styl: { opacity: 0, partName: 'frontBumper', position: 'absolute', top: '29.1%', left: '0.01%', width: '4.4%' } },
        { id: 27, srcT: require("@/assets/Front Panel.png"), styl: { opacity: 0, partName: 'visor', position: 'absolute', top: '41.1%', left: '4.01%', width: '3.4%' } },
        { id: 28, srcT: require("@/assets/Fog Light.png"), styl: { opacity: 0, partName: 'frontFogLightRight', position: 'absolute', top: '32.4%', left: '0.3%', width: '2.25%' } },
        { id: 29, srcT: require("@/assets/Fog Light.png"), styl: { opacity: 0, partName: 'frontFogLightLeft', position: 'absolute', top: '60.7%', left: '0.3%', width: '2.25%' } },
        { id: 17, srcT: require("@/assets/Left Block Headlight.png"), styl: { opacity: 0, partName: 'frontHeadlightRight', position: 'absolute', top: '34.1%', left: '4%', width: '3.45%' } },
        { id: 18, srcT: require("@/assets/Block Headlight.png"), styl: { opacity: 0, partName: 'frontHeadlightLeft', position: 'absolute', top: '58.8%', left: '4%', width: '3.45%' } },

        { id: 19, srcT: require("@/assets/Right Turn Headlight.png"), styl: { opacity: 0, partName: 'frontTurnSignalRight', position: 'absolute', top: '65.3%', left: '4.1%', width: '3.3%' } },
        { id: 20, srcT: require("@/assets/Left Turn Headlight.png"), styl: { opacity: 0, partName: 'frontTurnSignalLeft', position: 'absolute', top: '30.1%', left: '4%', width: '3.4%' } },

        { id: 21, srcT: require("@/assets/Wing.png"), styl: { opacity: 0, partName: 'frontFenderLeft', position: 'absolute', top: '76.1%', left: '15.4%', width: '16.0%' } },
        { id: 22, srcT: require("@/assets/Left Wing.png"), styl: { opacity: 0, partName: 'frontFenderRight', position: 'absolute', top: '14.1%', left: '15.4%', width: '16.0%' } },

        { id: 30, srcT: require("@/assets/Locker.png"), styl: { opacity: 0, partName: 'frontWheelWellLeft', position: 'absolute', top: '82.2%', left: '18.5%', width: '13.8%' } },
        { id: 31, srcT: require("@/assets/Left Locker.png"), styl: { opacity: 0, partName: 'frontWheelWellRight', position: 'absolute', top: '5.3%', left: '18.5%', width: '13.8%' } },
        { id: 36, srcT: require("@/assets/Back Wing.png"), styl: { opacity: 0, partName: 'backFenderLeft', position: 'absolute', top: '66.2%', left: '59.3%', width: '22.15%' } },
        { id: 37, srcT: require("@/assets/Back Wing Left.png"), styl: { opacity: 0, partName: 'backFenderRight', position: 'absolute', top: '14.5%', left: '59.2%', width: '22.15%' } },
        { id: 50, srcT: require("@/assets/Back Barbell.png"), styl: { opacity: 0, partName: 'backPillarLeft', position: 'absolute', top: '66.6%', left: '59.2%', width: '10.2%' } },
        { id: 51, srcT: require("@/assets/Left Back Barbell.png"), styl: { opacity: 0, partName: 'backPillarRight', position: 'absolute', top: '16.8%', left: '59.2%', width: '10.2%' } },

        { id: 38, srcT: require("@/assets/Back Locker.png"), styl: { opacity: 0, partName: 'backWheelWellLeft', position: 'absolute', top: '82.2%', left: '59.25%', width: '14.2%' } },
        { id: 39, srcT: require("@/assets/Left Back Locker.png"), styl: { opacity: 0, partName: 'backWheelWellRight', position: 'absolute', top: '5.15%', left: '59.25%', width: '14.2%' } },

        { id: 13, srcT: require("@/assets/Wheel.png"), styl: { opacity: 0, partName: 'frontWheelLeft', position: 'absolute', top: '85.5%', left: '20.6%', width: '9.5%' } },
        { id: 14, srcT: require("@/assets/Wheel.png"), styl: { opacity: 0, partName: 'backWheelLeft', position: 'absolute', top: '85.5%', left: '61.95%', width: '9.5%' } },
        { id: 15, srcT: require("@/assets/Wheel.png"), styl: { opacity: 0, partName: 'frontWheelRight', position: 'absolute', top: '0%', left: '20.6%', width: '9.5%' } },
        { id: 16, srcT: require("@/assets/Wheel.png"), styl: { opacity: 0, partName: 'backWheelRight', position: 'absolute', top: '0%', left: '61.95%', width: '9.5%' } },


        { id: 23, srcT: require("@/assets/Disk.png"), styl: { opacity: 0, partName: 'frontDiskLeft', position: 'absolute', top: '88.15%', left: '22.6%', width: '5.5%' } },
        { id: 24, srcT: require("@/assets/Disk.png"), styl: { opacity: 0, partName: 'backDiskLeft', position: 'absolute', top: '88.15%', left: '64.1%', width: '5.5%' } },
        { id: 25, srcT: require("@/assets/Disk.png"), styl: { opacity: 0, partName: 'frontDiskRight', position: 'absolute', top: '2.85%', left: '22.6%', width: '5.5%' } },
        { id: 26, srcT: require("@/assets/Disk.png"), styl: { opacity: 0, partName: 'backDiskRight', position: 'absolute', top: '2.85%', left: '64.1%', width: '5.5%' } },


        { id: 32, srcT: require("@/assets/Back Door.png"), styl: { opacity: 0, partName: 'backDoorLeft', position: 'absolute', top: '65.8%', left: '50.4%', width: '15.6%' } },
        { id: 33, srcT: require("@/assets/Left Back Door.png"), styl: { opacity: 0, partName: 'backDoorRight', position: 'absolute', top: '9%', left: '50.4%', width: '15.6%' } },
        { id: 34, srcT: require("@/assets/Back Door Window.png"), styl: { opacity: 0, partName: 'backDoorWindowLeft', position: 'absolute', top: '66.9%', left: '50.8%', width: '12.75%' } },
        { id: 35, srcT: require("@/assets/Back Door Window.png"), styl: { opacity: 0, partName: 'backDoorWindowRight', position: 'absolute', top: '23.5%', left: '50.8%', width: '12.75%', transform: 'rotate(180deg) scaleX(-1)' } },
        { id: 52, srcT: require("@/assets/Underfoot.png"), styl: { opacity: 0, partName: 'frontFootboardLeft', position: 'absolute', top: '90.5%', left: '32.4%', width: '16.8%' } },
        { id: 53, srcT: require("@/assets/Right Underfoot.png"), styl: { opacity: 0, partName: 'frontFootboardRight', position: 'absolute', top: '5.5%', left: '32.4%', width: '16.8%' } },
        { id: 56, srcT: require("@/assets/Back Underfoot.png"), styl: { opacity: 0, partName: 'backFootboardLeft', position: 'absolute', top: '90.6%', left: '50.8%', width: '9.4%' } },
        { id: 57, srcT: require("@/assets/Right Back Underfoot.png"), styl: { opacity: 0, partName: 'backFootboardRight', position: 'absolute', top: '5.5%', left: '50.8%', width: '9.4%' } },

        { id: 45, srcT: require("@/assets/Back Bumper.png"), styl: { opacity: 0, partName: 'backBumper', position: 'absolute', top: '27.8%', left: '89.2%', width: '4.65%' } },
        { id: 40, srcT: require("@/assets/Light Reflector.png"), styl: { opacity: 0, partName: 'backLightReflectorLeft', position: 'absolute', top: '30.9%', left: '92.1%', width: '1.3%' } },
        { id: 41, srcT: require("@/assets/Light Reflector.png"), styl: { opacity: 0, partName: 'backLightReflectorRight', position: 'absolute', top: '58.6%', left: '91.9%', width: '1.3%' } },
        { id: 42, srcT: require("@/assets/Muffler.png"), styl: { opacity: 0, partName: 'muffler', position: 'absolute', top: '61.1%', left: '93.5%', width: '6.5%' } },
        { id: 43, srcT: require("@/assets/Back Headlight.png"), styl: { opacity: 0, partName: 'backTailLightLeft', position: 'absolute', top: '61.6%', left: '84.95%', width: '4.5%' } },
        { id: 44, srcT: require("@/assets/Left Back Headlight.png"), styl: { opacity: 0, partName: 'backTailLightRight', position: 'absolute', top: '27.6%', left: '85.15%', width: '4.5%' } },

        { id: 46, srcT: require("@/assets/Panel.png"), styl: { opacity: 0, partName: 'dashboard', position: 'absolute', top: '37.1%', left: '85.1%', width: '4.55%' } },
        { id: 47, srcT: require("@/assets/Spoiler.png"), styl: { opacity: 0, partName: 'spoiler', position: 'absolute', top: '30.9%', left: '81.35%', width: '3.6%' } },
      ];
    },

    getDefaultImagesIn() {
      return [
        { id: 1, srcT: require("@/assets/Armchair.png"), styl: { opacity: 0, partName: 'interiorLeftSeat', position: 'absolute', top: '28.8%', left: '26.8%', width: '30.6%' } },
        { id: 2, srcT: require("@/assets/Armchair.png"), styl: { opacity: 0, partName: 'interiorRightSeat', position: 'absolute', top: '28.8%', left: '59.6%', width: '30.6%' } },
        { id: 3, srcT: require("@/assets/Armchair.png"), styl: { opacity: 0, partName: 'interiorFrontSeat', position: 'absolute', top: '53.6%', left: '59.6%', width: '30.6%' } },
        { id: 4, srcT: require("@/assets/Armchair.png"), styl: { opacity: 0, partName: 'interiorRearSeat', position: 'absolute', top: '53.6%', left: '26.8%', width: '30.6%' } },
        { id: 6, srcT: require("@/assets/Front Door Right Salone.png"), styl: { opacity: 0, partName: 'interiorLeftDoor', position: 'absolute', top: '0%', left: '20.5%', width: '41.4%' } },
        { id: 7, srcT: require("@/assets/Front Door Left Salone.png"), styl: { opacity: 0, partName: 'interiorRightDoor', position: 'absolute', top: '75%', left: '20.5%', width: '41.4%' } },
        { id: 8, srcT: require('@/assets/Inside Front Door Right Salone.png'), styl: { opacity: 0, partName: 'interiorRightDoorPanel', position: 'absolute', top: '12.8%', left: '26.2%', width: '29.7%' } },
        { id: 9, srcT: require('@/assets/Inside Front Door Left Salone.png'), styl: { opacity: 0, partName: 'interiorLeftDoorPanel', position: 'absolute', top: '78.8%', left: '26.2%', width: '29.7%' } },
        { id: 10, srcT: require("@/assets/Back Door Right Salone.png"), styl: { opacity: 0, partName: 'interiorRearDoor', position: 'absolute', top: '0%', left: '63.6%', width: '36.4%' } },
        { id: 11, srcT: require("@/assets/Back Door Left Salone.png"), styl: { opacity: 0, partName: 'interiorFrontDoor', position: 'absolute', top: '75%', left: '63.6%', width: '36.4%' } },
        { id: 8, srcT: require('@/assets/Inside Back Door Right Salone.png'), styl: { opacity: 0, partName: 'interiorFrontDoorPanel', position: 'absolute', top: '12.4%', left: '66.6%', width: '22.3%' } },
        { id: 8, srcT: require('@/assets/Inside Back Door Left Salone.png'), styl: { opacity: 0, partName: 'interiorRearDoorPanel', position: 'absolute', top: '79%', left: '66.6%', width: '22.3%' } },
        { id: 8, srcT: require("@/assets/Barbell Right Salone.png"), styl: { opacity: 0, partName: 'interiorBarbellRight', position: 'absolute', top: '0%', left: '58.9%', width: '6.45%' } },
        { id: 8, srcT: require("@/assets/Barbell Left Salone.png"), styl: { opacity: 0, partName: 'interiorBarbellRight', position: 'absolute', top: '75%', left: '58.9%', width: '6.45%' } },
        { id: 8, srcT: require("@/assets/Dashboard.png"), styl: { opacity: 0, partName: 'interiorDashboard', position: 'absolute', top: '27%', left: '0%', width: '20.2%' } },
        { id: 8, srcT: require("@/assets/Steering Wheel.png"), styl: { opacity: 0, partName: 'interiorSteeringWheel', position: 'absolute', top: '55.4%', left: '17%', width: '8.85%' } },
        { id: 8, srcT: require("@/assets/Multimedia.png"), styl: { opacity: 0, partName: 'interiorMultimedia', position: 'absolute', top: '45%', left: '9.85%', width: '9.8%' } },
      ];
    },

    setLabelWidth() {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1024) {
        this.labelWidth = '125px';
        this.dialogWidth = '75%';
      } else {
        this.labelWidth = '120px';
        this.dialogWidth = '90%';
      }
    },
    handleClose() {
      this.showModal = false;
      this.$emit("saved");
    },
    lastAccidentStatus() {
      LastAccidentStatus(this.accidentId).then((response) => {
        if (response && response.data) {
          this.accidentStatus = response.data;
        }
        else {

        }
      })
    },

    edit(id, accidentId, createUserId, readonly) {
      this.accidentId = accidentId;
      this.disabled = readonly;
      this.createUserId = createUserId;
      this.activeName = "auto1";
      GetParticipantReport(id).then((response) => {
        this.loading = false;
        if (response.data.data?.[0]) {
          this.showModal = true;
          this.item = response.data.data?.[0];
          this.item.participantId = id;
          this.item.accidentId = accidentId;
          this.lastAccidentStatus();
          [this.images, this.imagesIn].forEach(imagesArray => {
            imagesArray.forEach(image => {
              if (this.item.hasOwnProperty(image.styl.partName)) {
                image.styl.opacity = this.item[image.styl.partName];
              }
            });
          });
        } else {
          this.item = new ParticipantReport();
          this.images = this.getDefaultImages();
          this.imagesIn = this.getDefaultImagesIn();
          this.showModal = true;
          this.item.participantId = id;
          this.item.accidentId = accidentId;
        }
      });
    },



    handleClick(event) {
      const allImages = this.$refs.images;

      allImages.forEach((imageElement, index) => {
        const image = this.images.concat(this.imagesIn)[index];

        const rect = imageElement.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        if (x >= 0 && x <= rect.width && y >= 0 && y <= rect.height) {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = rect.width;
          canvas.height = rect.height;
          ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);
          const pixelData = ctx.getImageData(x, y, 1, 1).data;
          const alpha = pixelData[3];

          if (alpha !== 0) {
            const newOpacity = image.styl.opacity === 1 ? 0 : 1;
            this.$set(image.styl, 'opacity', newOpacity);

            this.$set(this.item, image.styl.partName, newOpacity);

            if (newOpacity === 1) {
              this.lastClickedPart = image.styl.partName;
            }
          }
        }
      });
    },

    clickSave() {
      const combinedImages = this.images.concat(this.imagesIn);

      this.$refs.images.forEach((imageElement, index) => {
        const correspondingImage = combinedImages[index];
        if (correspondingImage) {
          const partName = correspondingImage.styl.partName;
          this.$set(this.item, partName, imageElement.style.opacity === '1' ? 1 : 0);
        }
      });

      this.loading = true;
      let rep = Object.assign({}, this.item);
      rep.commandUserId = this.uid;

      if (this.uid === this.createUserId) {
        UpdateParticipantReport(rep).then((response) => {
          this.loading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0]
                  ? response.data.errors[0]
                  : this.$t('Səhv_əməliyyat'),
              });
            } else {
              this.showModal = false;
              this.$message({
                type: "success",
                message: this.$t('Uğurlu_əməliyyat'),
              });
              this.$emit("saved");
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: this.$t('Məlumatları_dəyişdirmək_səlahiyyətiniz_yoxdur'),
        });
      }
    },
  },
  watch: {
    accidentId(newVal, oldVal) {
      this.lastAccidentStatus();
    }
  },

  mounted() {
    this.setLabelWidth();
    window.addEventListener('resize', this.setLabelWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setLabelWidth);
  },
};
</script>

<style>
.main-image-container {
  position: relative;
}

.FullCarImg {
  width: 100%;
  height: 'auto';
}

.dialog-content {
  display: flex;
}


.main-image-container {
  flex: 3;
}

.selected-parts-list table {
  width: 100%;
  border-collapse: collapse;
}

.selected-parts-list th,
.selected-parts-list td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.selected-parts-list th {
  background-color: #f4f4f4;
}

.selected-parts-list tr:nth-child(even) {
  background-color: #f9f9f9;
}

.selected-parts-list tr:hover {
  background-color: #f1f1f1;
}

.main-image-container-2 {
  position: relative;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.custom-span {
  font-size: 20px;
  display: block;
  text-align: center;
  font-weight: bold;
}

.custom-span-left {
  font-size: 20px;
  font-weight: bold;
}
</style>